import { IntlShape } from "react-intl";
import { JsonSchema, RowData } from "../../../types";
import { SCHEMA_TITLES, ROW_DATA_KEYS } from "../constants";

export const getDeleteConfirmationMessage = ({
  rowData,
  setup,
  schema,
  intl,
}: {
  rowData: RowData;
  setup: string;
  schema: JsonSchema;
  intl: IntlShape;
}): {
  confirmationMessage: string;
  additionalMessage?: string;
} => {
  const defaultMessage = {
    confirmationMessage: intl.formatMessage({
      id: "dialog.deleteMessage",
      defaultMessage: "Are you sure you want to delete Record?",
    }),
    additionalMessage: undefined,
  };

  switch (setup) {
    case SCHEMA_TITLES.RECURRING_JOURNAL_ENTRIES: {
      const journalId = rowData[ROW_DATA_KEYS.JOURNAL_ID] as string;

      return {
        ...defaultMessage,
        confirmationMessage: intl.formatMessage(
          {
            id: "dialog.deleteRecurringEntry",
            defaultMessage:
              "Are you sure you want to delete this Recurring Entry tied to Journal {journalId}?",
          },
          { journalId },
        ),
      };
    }

    case SCHEMA_TITLES.CASH_CLEARING_SETUP: {
      const isApplicationGlobal =
        rowData[ROW_DATA_KEYS.INTEGRATING_APPLICATION] === null;

      const transactionType = rowData[ROW_DATA_KEYS.TRANSACTION_TYPE] as string;
      const labelOfTransactionType = schema.properties?.[ROW_DATA_KEYS.TRANSACTION_TYPE].enumLabels?.[transactionType];

      if (isApplicationGlobal && labelOfTransactionType) {
        return {
          ...defaultMessage,
          additionalMessage: intl.formatMessage({
            id: "dialog.deleteGlobalCashClearingSetupWarning",
            defaultMessage:
              "Deleting this Global record will also delete all LOS definitions configured for {labelOfTransactionType}.",
          }, {labelOfTransactionType}),
        };
      }

      return defaultMessage;
    }

    default:
      return defaultMessage;
  }
};
